import React, {Component} from "react";
import {Layout, Form, Input, Select, Button, message} from "antd";
import Header from "../../components/header";
import {
    reqAddIllQuestion,
    reqCaseDetail,reqEditIllQuestion,
    reqIllCaseList,
    reqUpload
} from "../../api";
import './illEdit.less'

const {Content} = Layout;
const {Option} = Select;
const {TextArea} = Input;
const {Sider} = Layout;

/**
 * 问题提问路由组件
 */
export class IllEdit extends Component {

    state = {
        caseId: '',
        ill: {},
        imgId: '',
        illCaseList:[],
        illId:''
    };

    imgClick = () => {
        document.getElementById("upload").click();
    };

    inputImg = async (e) => {
        let file = e.target.files[0];   //选择的图片文件
        let data = new FormData();
        data.append('file', file);

        let fileMaxSize = 1024*2;//2M
        let size = file.size/1024;
        if (size > fileMaxSize) {
            message.error("图片大小不能大于2M！");
        } else {
            const result = await reqUpload(data);
            this.setState({
                imgId: result.data
            });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields (async (err, values) => {
            if (!err) {
                let optArr = values.options.split('\n');
                let option = [];
                for (let i = 0; i < optArr.length; i++) {
                    option[i]={"optionKey":String.fromCharCode(65+i),"optionValue":optArr[i]};
                }
                let data ={
                    "questionType":values.questionType,
                    "imgs":[this.state.imgId],
                    "options":option,
                    "question":values.question,
                    "correctAnswer":values.correctAnswer
                };
                let result={};
                let mes = "";
                if(this.state.caseId === 'none'||this.state.caseId===""){
                    result = await reqAddIllQuestion(values.numId,data);
                    mes = "添加";
                }else {
                    data["id"] = values.id;
                    result = await reqEditIllQuestion(values.numId,data);
                    mes = "修改";
                }
                if(result.code === '000000') {
                    message.success(mes+"成功");
                    window.location.reload();
                }
            }
        });
    };

    getCaseDetail = async (id,caseId) => {
        const result = await reqCaseDetail(id);
        const questions = result.data.questions;
        let data = {};
        for (let i = 0; i < questions.length; i++) {
            if((caseId-0)===questions[i].id){
                data = questions[i];
                break;
            }
        }
        let options='';
        for (let i = 0; i < data.options.length; i++) {
            options += data.options[i].optionValue;
            if(i < data.options.length-1){
                options +="\n"
            }
        }
        data.options = options;
        if(data.imgs){
            this.state.imgId = data.imgs[0]
        }
        this.setState({
            ill:data
        })
    };

    selectChange = e => {
        if (e === 'B') {
            this.setState({
                add: 'inline-block'
            })
        } else {
            this.setState({
                add: 'none'
            })
        }
    };

    backToList = ()=> {
        sessionStorage.setItem("caseTo","/illQuestion");
        this.props.history.goBack();
    };

    getIllCaseList = async (data) =>{
        const result = await reqIllCaseList(data);
        if(result.code === '000000') {
            this.setState({
                illCaseList:result.data.rows
            })
        }else {
            message.error(result.msg);
        }
    };

    componentDidMount = async () => {
        let caseId = sessionStorage.getItem("caseId");
        let illId = sessionStorage.getItem("illId");
        if (caseId !== 'none') {
            this.setState({
                caseId: caseId
            });
            this.getCaseDetail(illId,caseId);
        }
        this.setState({
            illId: illId
        });
        this.getIllCaseList({
            size:100,
            page:1
        });
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render() {
        const {ill,  illCaseList,illId} = this.state;
        const {getFieldDecorator} = this.props.form;
        let self = this;

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Sider>
                        <div className='type_q'>
                            <span>
                                病例考核试题
                            </span>
                        </div>
                    </Sider>
                    <Content>
                        <div className='ill_box'>
                            <Form onSubmit={this.handleSubmit} className='edit_form' labelCol={{span: 3}}>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue:ill.id,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item label={'病例'} className='line'>
                                    {getFieldDecorator('numId', {
                                        initialValue:illId-0,
                                        rules: [{ required: true, message: '请选择病例!' }],
                                    })(
                                        <Select>
                                            {
                                                illCaseList&&illCaseList.map((item, index) => (
                                                    <Option key={index} value={item.id}>{item.title}</Option>
                                                ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item label={'题型分类'} className='line'>
                                    {getFieldDecorator('questionType', {
                                        initialValue:ill.questionType,
                                        rules: [{required: true, message: '请选择试题分类!'}]
                                    })(
                                        <Select className='edit_select'>
                                            <Option value={"A"}>单选</Option>
                                            <Option value={"X"}>多选</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item label={'题干'} className='auto_q'>
                                    {getFieldDecorator('question', {
                                        initialValue:ill.question,
                                        rules: [{required: true, message: '请输入题干!'}]
                                    })(<Input placeholder={'请输入题干'} className='edit_input'
                                              autoComplete={"off"}/>)}
                                </Form.Item>
                                <Form.Item label={'正确答案'} labelCol={{offset: 3}}>
                                    {getFieldDecorator('correctAnswer', {
                                        initialValue:ill.answer,
                                        rules: [{required: true, message: '请输入正确答案!'}]
                                    })(<Input placeholder={'如:A（多选请用|分开，如A|C）'} className='edit_input'
                                              style={{width: 300}} autoComplete={"off"}/>)}
                                </Form.Item>
                                <Form.Item label="选项" >
                                    {getFieldDecorator('options', {
                                        initialValue: ill.options,
                                        rules: [{required: true, message: '请输入选项!'}],
                                    })(<TextArea className='edit_text' rows={4} placeholder={'请输入选项，一行一个选项'}/>)}
                                </Form.Item>
                                <Form.Item wrapperCol={{offset: 18}}>
                                    <div className='img_list'>
                                        <img className='upload_img'
                                             src={this.state.imgId ? global.constant.uploadImage + this.state.imgId : require('../../assets/images/upload_img.png')}
                                             onClick={this.imgClick.bind(this)}/>
                                        <Input name="file" accept="image/*" id="upload"
                                               type="file" style={{opacity: 0, display: 'none'}}
                                               onChange={this.inputImg.bind(this)}/>
                                    </div>
                                    <span>上传一张题干图片</span>
                                </Form.Item>
                                <Form.Item wrapperCol={{offset: 10}}>
                                    <Button className='edit_cancel' onClick={this.backToList.bind(this)}>
                                        取消
                                    </Button>
                                    <Button type="primary" htmlType="submit" className='edit_submit'>
                                        发布
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapIllEdit = Form.create()(IllEdit);
export default WrapIllEdit;